import { onWaiting, onLoggedIn } from '../../Actions';

export const signIn = (data) => {
    return (dispatch, getState, { api, history, session }) => {
        dispatch(onWaiting(true));
        api.post('/auth', data, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                const { token, profile, countries, sports } = response;

                session.setItem('profile', profile);
                session.setItem('countries', countries);
                session.setItem('sports', sports);
                session.setItem('token', token);
                dispatch(onLoggedIn(true));
                history.push(`/profile`)
            })
    }
}

export const forgot = (data, cb) => {
    return (dispatch, getState, { api, history, session, alert }) => {
        dispatch(onWaiting(true));
        api.post('/password', data, dispatch)
            .then(response => {
                dispatch(onWaiting(false));
                if(!response) return;
                alert.success(response.message);
                cb();
                history.push(`/sign-in`);
            })
    }
}


// WEBPACK FOOTER //
// ./src/sign-in/actions/index.js